var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStaplePin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 334,
    viewBox: "0 0 38 334",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_28",
    x: -8,
    y: -8,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_29",
    x: -8,
    y: 288,
    width: 54,
    height: 54,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.978,
    x2: 0,
    y2: 0.978,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53565a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#adafb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53565a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-first_page_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 334
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "first_page_1",
    "data-name": "first page \\u2013 1",
    clipPath: "url(#clip-first_page_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(-9573 -1032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(8884 799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460",
    transform: "translate(638 220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 51, 13)",
    filter: "url(#Ellipse_28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_28-2",
    "data-name": "Ellipse 28",
    transform: "translate(8 8)",
    stroke: "#6f6f6f",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 13,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 51, 13)",
    filter: "url(#Ellipse_29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_29-2",
    "data-name": "Ellipse 29",
    transform: "translate(8 304)",
    stroke: "#6f6f6f",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 13,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    transform: "translate(59 24)",
    stroke: "#53565a",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 312,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 311,
    rx: 9.5,
    fill: "none"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStaplePin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/staple-pin.0d740bf8be0aa1ed11cc99d4ed2cade0.svg";